import axios from 'axios';
import Readmore from "readmore-js";
import flatpickr from 'flatpickr';
import FlatpickrLanguages from 'flatpickr/dist/l10n';
import swal from 'sweetalert';

export default class psMessages {
    constructor(el) {
        if (!el) {
            return;
        }

        this.container = el;
        this.editSectionNode = document.getElementById('ps-messages-edit-section');
        this.informationMessage = this.editSectionNode.querySelector(".ps-messages-edit-section__information-message").querySelector('ul');

        this.getMessagesUrl = this.container.getAttribute('data-get-messages-url');
        this.createMessageUrl = this.container.getAttribute('data-create-message-url');
        this.updateMessageUrl = this.container.getAttribute('data-update-message-url');
        this.saveSettingsUrl = this.container.getAttribute('data-save-settings-url');
        this.addSavedMessageUrl = this.container.getAttribute('data-add-saved-message-url');
        this.removeSavedMessageUrl = this.container.getAttribute('data-remove-saved-message-url');
        this.searchAuthorUrl = this.container.getAttribute('data-search-author-url');
        this.likeMessageUrl = this.container.getAttribute('data-like-message-url');
        this.deleteButton = this.editSectionNode.querySelector(".delete-button");

        this._init();
    }

    _init() {

        // Hantering av olika klick i titelraden
        this.container.addEventListener('click', event => {
            const btn = event.target;

            // Skapa meddelande
            if (btn.id === 'ps-create-message') {
                this._resetMessageForm();
                this._toggleEditSection(true);
                //Dölj radera knappen
                this.deleteButton.setAttribute("hidden", true);
                return;
            }

            // Filtrering
            if (btn.classList.contains('filter-toggle')) {
                this._toggleFilterForm();
                return;
            }

            // Inställningar
            if (btn.classList.contains('settings-toggle')) {
                this._toggleSettingsForm();
                return;
            }

            // Inställningar - pulldowns
            if (btn.matches('.content-toggle[aria-controls]')) {
                const content = document.getElementById(btn.getAttribute('aria-controls'));
                if (content) {
                    const expanded = btn.getAttribute('aria-expanded') === 'true';
                    content.toggleAttribute('hidden', expanded);
                    btn.setAttribute('aria-expanded', !expanded);
                }
                return;
            }
        });

        // Hantering av olika klick i meddelandeflödet
        const messages = this.container.querySelector('.ps-messages-container');
        messages.addEventListener('click', event => {

            // Redigera meddelande
            if (event.target.classList.contains('edit-message')) {
                this._resetMessageForm();

                const msgNode = event.target.closest('.ps-messages__message');

                this.editSectionNode.setAttribute('data-editing-id', msgNode.getAttribute('data-id'));

                //const headingElement = document.getElementById('ps-messages-edit-heading');
                //headingElement.innerText = headingElement.dataset.edit;

                const titleText = msgNode.querySelector('.ps-messages__title').innerText;
                const contentHtml = msgNode.querySelector('.ps-messages__body').innerHTML;

                document.getElementById('ps-messages-edit-section__message-heading').value = titleText;
                tinymce.get("ps-messages-editor").setContent(contentHtml);
                document.getElementById('ps-signature').value = msgNode.dataset.signature;
                /*document.getElementById('ps-messages-author').value = msgNode.dataset.author;*/

                // Roller
                const rolesNode = this.editSectionNode.querySelector('input.role').closest('.ps-messages-edit-section__academy');
                let roles = msgNode.querySelector('input.selected-roles');
                roles = (roles && roles.value.split(',')) || [];

                if (roles.length && !roles.includes('ALLROLES')) {
                    const subNode = rolesNode.querySelector('.ps-messages-edit-section__section-wrapper');
                    subNode.querySelectorAll('input.role').forEach(cb => cb.checked = roles.includes(cb.value));
                    const checked = subNode.querySelector('input.role:checked');
                    if (checked) {
                        const all = rolesNode.querySelector('input#ALLROLES');
                        all.disabled = all.checked = false;
                        checked.dispatchEvent(new Event('change', { bubbles: true }));
                        this._toggleAccordion(rolesNode, true);
                    }
                }

                // Enheter
                let orgs = msgNode.querySelector('input.selected-orgs');
                orgs = (orgs && orgs.value.split(',')) || [];
                //let sections = msgNode.querySelector('input.selected-sections');
                //sections = (sections && sections.value.split(',')) || [];

                for (const input of this.editSectionNode.querySelectorAll('input.academy')) {
                    input.checked = orgs.includes(input.value);
                    if (input.checked) {
                        input.dispatchEvent(new Event('change', { bubbles: true }));
                    }
                }
                for (const input of this.editSectionNode.querySelectorAll('input.section')) {
                    input.checked = orgs.includes(input.value) && !input.disabled;
                    if (input.checked) {
                        this._toggleAccordion(input, true);
                    }
                }

                this._toggleEditSection(true);

                //Updatera informationsruta.
                this._updateInformationBox();

                //Visa radera knappen
                this.deleteButton.removeAttribute("hidden");

                return;
            }

            // Markera/avmarkera favorit ps-meddelanden ikonen och spara id:s.
            if (event.target.classList.contains('save-message')) {
                const msg = event.target.closest('.ps-messages__message');
                const isSaved = msg.classList.contains('is-saved');
                const url = isSaved ? this.removeSavedMessageUrl : this.addSavedMessageUrl;
                const id = msg.dataset.id;

                axios.post(url, id, {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                })
                    .then(() => {
                        msg.classList.toggle('is-saved', !isSaved);
                    })
                    .catch(error => {
                        this._error(error);
                    });

                return;
            }

            // Gilla meddelande
            if (event.target.classList.contains('ps-messages__like-message')) {
                this._likeMessage(event.target);
                return;
            }
        });

        this.container.addEventListener('click', event => {
            // "Visa mer"
            if (event.target.classList.contains('ps-messages__show-more')) {
                this._updateMessages(true);
            }
        });

        this._initSettings();
        this._initFiltering();
        this._initEditing();
        this._initTinyMce();

        document.addEventListener('DOMContentLoaded', () => this._readmore(), { once: true });
    }

    _initSettings() {
        const settings = document.getElementById('psMessageSettings');

        settings && settings.addEventListener('submit', event => {
            event.preventDefault();

            const form = event.target;
            const btn = form.querySelector('button[type="submit"]');

            btn.classList.toggle('loading', true);

            axios.post(form.action, new FormData(form))
                .then(response => {
                    const messages = this.container.querySelector('.ps-messages-container');
                    messages.innerHTML = response.data;
                    this._readmore();

                    return this._updateFilterForm().then(() => this._updateMessages());
                })
                .catch(error => {
                    this._error(error);
                })
                .finally(() => {
                    setTimeout(() => {
                        btn.classList.toggle('loading', false);
                        this._toggleSettingsForm(false);
                    }, 500);
                });
        });
    }

    _toggleSettingsForm(state) {
        const settings = document.getElementById('psMessageSettings');
        if (state === false && settings.hasAttribute('hidden')) {
            return;
        }

        const btn = this.container.querySelector(`button[aria-controls='${settings.id}']`);
        state = state == null ? !(btn.getAttribute('aria-expanded') === 'true') : state === true;

        if (state) {
            this._toggleFilterForm(false);
        }

        settings.toggleAttribute('hidden', !state);
        btn.setAttribute('aria-expanded', state);
    }


    _initFiltering() {

        const filterContainer = this.container.querySelector('.ps-messages-filters-container');

        if (!filterContainer) {
            return;
        }

        let authorSearchTimeout = null;

        // Filtrera på avsändare, filtrering sker vid minst 2 bokstäver
        const authorChangeEventHandler = event => {
            clearTimeout(authorSearchTimeout);
            if (!(event.target.tagName === 'INPUT' && event.target.type === 'text')) {
                return;
            }
            if (event.type === 'focus' && authorSearchInput.dataset.value) {
                return;
            }
            const authorSearchInput = filterContainer.querySelector('input.author-search-input');
            const authorSearchResult = filterContainer.querySelector('.author-search-results');
            delete authorSearchInput.dataset.value;
            authorSearchResult.toggleAttribute('hidden', true);
            if (authorSearchInput.value.length >= 2) {
                authorSearchTimeout = setTimeout(() => this._updateFilterAuthors(authorSearchInput), 800);
            }
        };

        // Hantering av klick inuti filterformuläret
        filterContainer.addEventListener('click', event => {
            const elem = event.target;

            // Markera avsändare och dölj förslagslistan
            if (elem.classList.contains('author-search-result-item')) {
                const authorSearchInput = filterContainer.querySelector('input.author-search-input');
                const authorSearchResult = filterContainer.querySelector('.author-search-results');
                const signature = event.target.closest('[data-signature]').dataset.signature;
                authorSearchInput.dataset.value = signature;
                authorSearchInput.value = elem.innerText;
                authorSearchResult.toggleAttribute('hidden', true);
                return;
            }

            // Rensa innehåll i en input
            if (elem.classList.contains('clear-input-button')) {
                const field = elem.closest('.input-field');
                const input = field && field.querySelector('input[type=text]');
                if (input) {
                    input.value = '';
                    input.removeAttribute('data-value');
                }
                return;
            }

            // Rensa aktiva filter
            if (elem.classList.contains('clear-active-filter-button')) {
                this._clearFilterForm(true);
                return;
            }
        });

        filterContainer.addEventListener('change', event => {
            if (event.target.type === 'checkbox') {
                const label = event.target.closest('label');
                label.classList.toggle('is-checked', event.target.checked);
            }
        });
        filterContainer.addEventListener('input', authorChangeEventHandler);
        filterContainer.addEventListener('focus', authorChangeEventHandler);
        // Dölj förslagslistan om man trycker utanför den
        document.addEventListener('click', event => {
            if (!event.target.matches('.author-search-results .author-search-result-item')) {
                const authorSearchResult = filterContainer.querySelector('.author-search-results');
                authorSearchResult && authorSearchResult.toggleAttribute('hidden', true);
            }
        });

        // Rensa filterformulär
        filterContainer.addEventListener('reset', event => {
            event.preventDefault();
            this._clearFilterForm();

        });
        // Submit ("filtrera")
        filterContainer.addEventListener('submit', event => {
            event.preventDefault();
            this._updateMessages();
        });

        this._initDatePickers(filterContainer);
    }

    _initDatePickers(container) {
        // Start och slut datum
        const flatPickrConfig = {
            dateFormat: "Y-m-d",
            enableTime: false,
            weekNumbers: true,
            altInput: true,
            altFormat: "j F Y",
            locale: (document.documentElement.lang || 'sv') === 'sv' ? FlatpickrLanguages['sv'] : FlatpickrLanguages['en']
        };

        container.querySelectorAll('.flatpickr-date').forEach(fp => {
            const cfg = { ...flatPickrConfig, wrap: fp.tagNamn !== 'INPUT' };
            flatpickr(fp, cfg);
        });
    }

    _initEditing() {
        if (!this.editSectionNode) {
            return;
        }

        this.editSectionNode.addEventListener('click', event => {
            if (event.target.classList.contains('ps-messages-edit-section__chevron')) {
                this._toggleAccordion(event.target);
            } else if (event.target.closest('.close-button')) {
                this._toggleEditSection(false);
            } else if (event.target.matches('button[type=button].delete-button')) {
                this._deleteCurrentMessage();
            } else {
                return;
            }

            event.preventDefault();
        });

        this.editSectionNode.addEventListener('change', event => {
            if (!event.target.matches('.ps-messages-edit-section__academy input[type=checkbox]')) {
                return;
            }

            const cb = event.target;
            const container = cb.closest('.ps-messages-edit-section__academy');

            // Check/uncheck Alla beroende på om någon roll är vald
            if (cb.classList.contains('role')) {
                const allRoles = container.querySelector('input#ALLROLES');
                const inputs = Array.from(container.querySelectorAll('.ps-messages-edit-section__section-wrapper input[type=checkbox]'));

                if (cb === allRoles) {
                    inputs.forEach(c => c.checked = false);
                }

                allRoles.disabled = allRoles.checked = !inputs.some(c => c.checked);
            }

            if (cb.classList.contains('academy')) {
                for (const ccb of container.querySelectorAll('.ps-messages-edit-section__section-wrapper input[type=checkbox]')) {
                    ccb.checked = cb.checked ? false : ccb.checked;
                    ccb.disabled = cb.checked;
                }
            }

            // Uppdatera informationsruta
            this._updateInformationBox();
        });

        this.editSectionNode.addEventListener('submit', event => {
            event.preventDefault();

            if (!this._validateMessageForm()) {
                return;
            }
            const contentId = this.editSectionNode.getAttribute('data-editing-id');
            const updating = !!(contentId);

            const url = updating ? this.updateMessageUrl : this.createMessageUrl;

            const data = {
                heading: document.getElementById('ps-messages-edit-section__message-heading').value,
                content: tinymce.get("ps-messages-editor").getContent(),
                signature: document.getElementById('ps-signature').value,
                academies: this._getAllCheckedValues('input.academy'),
                sections: this._getAllCheckedValues('input.section'),
                roles: this._getAllCheckedValues('input.role'),
                language: document.documentElement.lang || 'sv'
            };

            if (updating) {
                data.contentId = contentId;
            }

            const button = event.target.querySelector('button[type="submit"]');
            button.classList.toggle('loading', true);

            axios.post(url, data)
                .then((response) => {
                    const container = this.container.querySelector('.ps-messages-list-wrapper');
                    if (!container) {
                        return;
                    }

                    const div = document.createElement('div');
                    div.innerHTML = response.data;

                    if (contentId) { // uppdatera
                        const idAttr = '[data-id="' + contentId + '"]';
                        const existing = container.querySelector(idAttr);
                        const updated = div.querySelector(idAttr);
                        // vanilla-js replaceWith
                        existing && updated && existing.replaceWith(updated);
                    } else {
                        const created = div.querySelector('[data-id]');
                        container.prepend(created);
                        const total = parseInt(container.getAttribute('data-message-count-total')) || 0;
                        container.setAttribute('data-message-count-total', total + 1);
                    }

                    this._readmore();
                })
                .catch(error => {
                    this._error(error);
                })
                .finally(() => {
                    button.classList.toggle('loading', false);
                    this._toggleEditSection(false);
                    this._resetMessageForm();
                });
        });
    }

    _toggleAccordion(elem, state) {
        const cntr = elem.closest('.ps-messages-edit-section__academy');
        elem = cntr.querySelector('.ps-messages-edit-section__chevron');

        // Loose equal!
        state = state != null ? !!state : elem.classList.contains('ps-messages-edit-section__chevron--closed');
        const acc = cntr.querySelector('.ps-messages-edit-section__section-wrapper');
        acc.toggleAttribute('hidden', !state);
        acc.setAttribute('aria-expanded', state);
        elem.classList.toggle('ps-messages-edit-section__chevron--closed', !state);
    }

    _toggleFilterForm(state) {
        const filters = document.getElementById('psMessageFilters');
        if (state === false && filters.hasAttribute('hidden')) {
            return;
        }

        const btn = this.container.querySelector(`button[aria-controls='${filters.id}']`);
        state = state == null ? !(btn.getAttribute('aria-expanded') === 'true') : state === true;

        if (state) {
            this._toggleSettingsForm(false);
        }

        filters.setAttribute('aria-hidden', !state);
        btn.setAttribute('aria-expanded', state);

        const activeContainer = this.container.querySelector('.ps-messages-active-filter');
        const activeFilter = activeContainer.querySelector('.active-filter-wrapper');
        activeContainer.setAttribute('aria-hidden', state || activeFilter.childElementCount === 0);
    }

    _toggleEditSection(state) {
        if (state) {
            const contentId = this.editSectionNode.getAttribute('data-editing-id');
            const isEditing = !!(contentId);

            // Uppdatera vilken header som skall visas
            const headers = this.editSectionNode.querySelectorAll('.ps-messages-edit-section__heading span');
            headers[0].toggleAttribute('hidden', !headers[1].toggleAttribute('hidden', !isEditing));
        }

        this.editSectionNode.toggleAttribute('hidden', !state);
        this.editSectionNode.setAttribute('aria-expanded', state);
    }

    _initTinyMce() {
        const textarea = document.getElementById('ps-messages-editor');

        if (!(tinymce && textarea)) {
            return;
        }

        const documentBaseUrl = this.container.getAttribute('data-base-url');

        let options = {
            language: 'sv_SE',
            selector: '#ps-messages-editor',
            branding: false,
            menubar: false,
            contextmenu: false,
            height: '250',
            plugins: 'link lists paste image',
            paste_as_text: true,
            relative_urls: false,
            remove_script_host: true,
            document_base_url: documentBaseUrl,
            link_assume_external_targets: 'https',
            content_style: 'body { font-family: "HarrietText"; font-size: 16px; line-height: 20px; letter-spacing: 0; }',
            toolbar: 'formatselect | bold italic bullist | link unlink | image',
            file_picker_types: 'file image',
            file_picker_callback: (cb, value, meta) => { this._imageFilePicker(cb, value, meta); },
            block_formats: 'Normal=p; Rubrik 2=h3;',
            placeholder: this._decodeHtmlText('H&auml;r skriver du ditt meddelande')
        };

        if (document.documentElement.lang === 'en') {
            options = {
                ...options,
                ...{
                    language: 'en_US',
                    block_formats: 'Normal=p; Heading=h3;',
                    placeholder: 'Write your message here'
                }
            };
        }

        tinymce.init(options);
    }

    _readmore(attr) {
        let templ = document.getElementById('psMessagesContinueReadingTemplate');
        templ = templ && templ.content && templ.content.querySelector('a');
        const moreLink = !templ ? '' : (elem) => this._buildMoreLink(templ, elem);

        // Readmore.js skall kunna använda elementets beräknade max-height som collapsedHeight, så boxarna kan vara kollapsade före readmore initierats.
        // Det verkar dock inte funka för element som läggs till i efterhand, som har max-height 'none'.
        // Därför behöver collapsedHeight sättas manuellt här, samt height på .ps-messages__wrapper sättas till samma värde
        const options = {
            speed: 70,
            collapsedHeight: 221, /* Synka detta med height på klassen .ps-messages__wrapper */
            lessLink: '',
            moreLink
        };

        // Kalla readmore med elementen direkt, blir fel med embeddad style annars, selectorn blir lite för omständig för readmore
        const selector = `.ps-messages__message${attr || ''} .ps-messages__wrapper:not([data-readmore])`; // Ignorera element som redan har readmore
        const elems = this.container.querySelectorAll(selector);

        new Readmore(elems, options);
    }

    _buildMoreLink(linkTempl, elem) {
        let header = elem.querySelector('.ps-messages__title');
        header = (header && header.innerText) || '';

        const link = linkTempl.cloneNode(true);
        const prefix = link.getAttribute('aria-label') || '';
        link.setAttribute('aria-label', `${prefix} "${header}"`);

        return link.outerHTML;
    }

    _validateMessageForm() {
        const swedish = document.documentElement.lang === 'sv';
        const errors = [];

        const heading = document.getElementById('ps-messages-edit-section__message-heading').value;
        if (heading.length === 0) {
            errors.push(swedish ? 'rubrik' : 'heading');
        }

        const editorNode = document.getElementById('ps-messages-editor');
        const message = tinymce.get(editorNode.id).getContent();
        if (message.length === 0) {
            errors.push(swedish ? 'meddelande' : 'message');
        }

        const signature = document.getElementById('ps-signature').value;
        if (signature.length === 0) {
            errors.push(swedish ? 'signatur' : 'signature');
        }

        const errorNode = document.getElementById('ps-messages-validation-error');

        if (errors.length === 0) {
            errorNode.style.display = 'none';
            return true;
        }

        const intro = swedish ? 'Du m&aring;ste fylla i ' : 'You must enter ';
        const separator = swedish ? ' och ' : ' and ';
        const fields = errors.length === 1 ? errors[0] : errors.slice(0, -1).join(', ') + separator + errors[errors.length - 1];

        errorNode.innerHTML = intro + fields + '.';
        errorNode.style.display = 'block';

        return false;
    }

    _getAllCheckedValues(inputSelector) {
        const inputs = this.editSectionNode.querySelectorAll(inputSelector + ':checked');
        const values = new Array(inputs.length);
        for (let i = 0; i < inputs.length; i++) {
            values[i] = inputs[i].value;
        }
        return values;
    }

    _error(error) {
        const id = (error && error.response && error.response.status === 401) ? 'ps-logged-out' : 'ps-generic-error';
        alert(document.getElementById(id).value);
    }

    _resetMessageForm() {
        this.editSectionNode.removeAttribute('data-editing-id');

        const form = this.editSectionNode.querySelector('form');
        form.reset();

        form.querySelectorAll('.ps-messages-edit-section__academy-header input[type=checkbox]').forEach(cb => {
            if (cb.classList.contains('role')) {
                cb.disabled = cb.checked = true;
            }
            this._toggleAccordion(cb, false);
            cb.dispatchEvent(new Event('change', { bubbles: true }));
        });
    }

    _decodeHtmlText(html) {
        const div = document.createElement('span');
        div.innerHTML = html;
        return div.innerHTML;
    }

    _toggleSavedMessage(button) {
        const id = button.value;
        const url = button.classList.contains('is-saved') ? this.removeSavedMessageUrl : this.addSavedMessageUrl;

        axios.post(url, { id })
            .then(() => {
                button.classList.toggle('is-saved');
            })
            .catch(error => {
                this._error(error);
            });
    }

    _updateFilterForm() {
        return axios.get('/api/ps/messages/filter')
            .then(response => {
                const form = this.container.querySelector('#psMessageFilters form');
                const parent = form.parentElement;
                parent.innerHTML = response.data;
                this._initDatePickers(parent);
            });
    }

    _updateFilterAuthors(input) {

        const text = input.value;
        input.setAttribute('data-value', '');

        const loader = this.container.querySelector(".author-filter-column .ajax-loading");
        loader.toggleAttribute('hidden', false);

        axios.get(this.searchAuthorUrl, { params: { text } })
            .then(response => {
                const results = this.container.querySelector('.author-search-results');
                results.innerHTML = response.data;
                results.toggleAttribute('hidden', results.childNodes.length == 0);
            })
            .catch(error => {
                this._error(error);
            })
            .finally(() => {
                loader.toggleAttribute('hidden', true);
            });
    }

    _updateMessages(loadMore) {

        loadMore = loadMore === true;

        const wrapper = this.container.querySelector('.ps-messages-list-wrapper');

        const filterData = loadMore && wrapper._filterData ? wrapper._filterData : this._getFilterData();
        const postData = { ...filterData.postData }; // Klona postData för att lägga till ytterligare data (tex skip) utan att ändra ursprungliga objektet

        if (loadMore) {
            postData.skip = wrapper.childElementCount;
        }

        const showMoreBtn = this.container.querySelector('.ps-messages__show-more');
        showMoreBtn && showMoreBtn.classList.toggle('loading', true);

        return axios.post(this.getMessagesUrl, postData)
            .then(response => {

                const div = document.createElement('div');
                div.innerHTML = response.data;

                let wrapper = this.container.querySelector('.ps-messages-list-wrapper');
                const newWrapper = div.firstElementChild;

                if (loadMore) {
                    wrapper.append(...newWrapper.children);
                } else {
                    wrapper.replaceWith(newWrapper);
                    wrapper = newWrapper;
                }

                this._readmore();

                const totalMsgCount = parseInt(wrapper.getAttribute('data-message-count-total')) || 0;
                showMoreBtn && showMoreBtn.toggleAttribute('hidden', totalMsgCount <= wrapper.childElementCount);

                if (!loadMore) {
                    this._updateActiveFilter(filterData);
                }
            })
            .catch(error => {
                this._error(error);
            })
            .finally(() => {
                showMoreBtn && showMoreBtn.classList.toggle("loading", false);
            });
    }

    _getFilterData() {
        const container = this.container.querySelector('.ps-messages-filters');

        const postData = {};
        const extra = {};

        const categories = container.querySelectorAll('input:checked');
        if (categories.length) {
            postData.categories = new Array(categories.length);
            for (let i = 0; i < categories.length; i++) {
                postData.categories[i] = categories[i].value;
            }
        }

        const authorInput = container.querySelector('input.author-search-input');
        if (authorInput && (authorInput.dataset.value || authorInput.value)) {
            postData.author = authorInput.dataset.value || authorInput.value;
            extra.authorText = authorInput.value;
        }

        const fromDateInput = container.querySelector('.flatpickr-input.from-date');
        if (fromDateInput && fromDateInput.value) {
            postData.fromDate = fromDateInput.value;
        }

        const toDateInput = container.querySelector('.flatpickr-input.to-date');
        if (toDateInput && toDateInput.value) {
            postData.toDate = toDateInput.value;
        }

        return { postData, extra };
    }

    _updateActiveFilter(filterData) {
        const messages = this.container.querySelector('.ps-messages-list-wrapper');
        const filters = this.container.querySelector('.active-filter-wrapper');

        if (!(messages && filters)) {
            return;
        }

        // Rensa gamla filterdata och innehåll
        delete messages._filterData;
        filters.innerHTML = '';

        if (!filterData || Object.keys(filterData.postData).length === 0) {
            return;
        }

        messages._filterData = filterData;

        if (filterData.postData.categories) {
            const categories = this.container.querySelector('.categories-filter');
            for (const value of filterData.postData.categories) {
                const input = categories.querySelector('input[value="' + value + '"]');
                const label = (input && input.label) || input.closest('label');
                if (label) {
                    filters.appendChild(this._createActiveFilterElement(label.innerText, 'category'));
                }
            }
        }

        if (filterData.extra.authorText) {
            filters.appendChild(this._createActiveFilterElement(filterData.extra.authorText, 'author'));
        }

        if (filterData.postData.fromDate || filterData.postData.toDate) {
            filters.appendChild(this._createActiveFilterElement((filterData.postData.fromDate || '') + ' &ndash; ' + (filterData.postData.toDate || ''), 'date'));
        }
    }

    _clearFilterForm(closeForm) {

        const filterContainer = this.container.querySelector('.ps-messages-filters');

        // Rensa kategorier
        const categories = filterContainer.querySelectorAll('.category-item');
        for (const category of categories) {
            category.querySelector('input').checked = false;
            category.classList.remove('is-checked');
        }

        // Rensa datum
        const dates = filterContainer.querySelectorAll('.flatpickr-date');
        for (const date of dates) {
            date._flatpickr && date._flatpickr.clear();
        }

        // Rensa författare
        const authorInput = filterContainer.querySelector('input.author-search-input');
        authorInput.value = '';
        authorInput.removeAttribute('data-value');

        // Uppdatera
        return this._updateMessages()
            .then(() => closeForm && this._toggleFilterForm(false));
    }

    _createActiveFilterElement(html, cssClass) {
        const div = document.createElement('div');
        div.innerHTML = html;
        div.classList.add('active-filter-item');
        cssClass && div.classList.add(cssClass);
        return div;
    }

    _imageFilePicker(cb, value, meta) {
        const swedish = document.documentElement.lang === 'sv';
        const input = document.createElement('input');
        input.setAttribute('type', 'file');
        input.onchange = () => {
            const file = input.files[0];
            const reader = new FileReader();
            reader.onload = function () {
                if (!(meta.filetype === "image" || meta.filetype === "file")) {
                    return;
                }

                const fileName = meta.filetype === "image" ? file.name.substr(0, file.name.lastIndexOf(".")) : file.name;
                const base64 = reader.result.split(',')[1];
                const blobCache = tinymce.activeEditor.editorUpload.blobCache;
                const blobInfo = blobCache.create(fileName, file, base64);

                blobCache.add(blobInfo);

                const data = new FormData();
                data.append('file', blobInfo.blob(), blobInfo.filename());

                axios.post('/api/ps/messages/upload', data)
                    .then(response => {
                        cb(response.data.location, { title: file.name });
                    })
                    .catch(error => {
                        if (error.response.status === 400) {
                            const msg = swedish ?
                                "En fil med samma namn finns redan. Du behöver döpa om filen för att ladda upp den." :
                                "A file with the same name is already uploaded. You need to rename the file to upload it.";
                            alert(msg)
                        } else {
                            error.message;
                        }
                    });
            };
            reader.readAsDataURL(file);
        }
        input.click();
    }

    _likeMessage(btn) {
        const msg = btn.closest('.ps-messages__message');

        axios.post(this.likeMessageUrl, { id: msg.dataset.id, userName: msg.dataset.user })
            .then(response => {
                const count = response.data || '';
                btn.querySelector('span').innerText = count;
                const currentSrc = btn.querySelector('img').getAttribute('src');
                btn.querySelector('img').src = currentSrc.includes("like.svg") && count ? "/img/ps-icons/like-green.svg" : "/img/ps-icons/like.svg";
            })
            .catch(error => {
                this._error(error);
            });
    }

    _updateInformationBox() {

        let roles = [];
        for (const input of this.editSectionNode.querySelectorAll("#psMessage_Subcategories_Roles input:checked")) {
            const text = this._getInputLabel(input);
            text && roles.push(text);
        }
        roles = !roles.length ? (document.documentElement.lang === 'sv' ? "Alla" : "All") : roles.join(", ");

        const orgs = [];
        for (const input of this.editSectionNode.querySelectorAll('input.academy:checked, input.section:checked')) {
            const text = this._getInputLabel(input);
            text && orgs.push(text);
        }

        const infoBox = this.informationMessage;
        infoBox.innerHTML = '';

        if (!orgs.length) {
            infoBox.innerHTML += '<li>' + roles + '</li>\n';
        } else {
            for (const org of orgs) {
                infoBox.innerHTML += `<li>${roles} under ${org}</li>\n`;
            }
        }
    }

    _getInputLabel(input) {
        const lbl = input.parentElement.querySelector('label');
        return lbl && lbl.innerHTML;
    }

    _deleteCurrentMessage() {
        const id = this.editSectionNode.getAttribute('data-editing-id');

        if (!id) {
            return;
        }

        const texts = document.documentElement.lang === 'en' ?
            {
                title: 'Your message will be deleted',
                text: 'Are you sure that you want to delete your message?',
                buttons: ['Cancel', 'OK']
            } :
            {
                title: 'Ditt meddelande kommer att raderas',
                text: 'Är du säker på att du vill radera ditt meddelande?',
                buttons: ['Avbryt', 'OK']
            };

        swal({
            icon: "warning",
            buttons: true,
            dangerMode: true,
            closeOnClickOutside: false,
            ...texts
        }).then(confirmed => {
            if (confirmed === true) {
                // ett objekt med { params: {} } gör axios om till query-parametrar
                return axios.delete("/api/ps/messages/delete", { params: { id } }).then(() => true);
            }
        }).then(deleted => {
            if (deleted === true) {
                const activeMsg = this.container.querySelector(`.ps-messages-container .ps-messages__message[data-id="${id}"]`);
                /*activeMsg && activeMsg.setAttribute("hidden", true)*/
                activeMsg && activeMsg.remove();

                return swal(document.documentElement.lang === 'sv' ? 'Ditt meddelande har raderats.' : 'Your message has been deleted.', {
                    icon: "success",
                });
            }
            else {
                return swal(document.documentElement.lang === 'sv' ? "Ditt meddelande är kvar." : "Your message remains");
            }
        }).catch(error => {
            this._error(error);
        }).then(() => {
            this._toggleEditSection(false);
        });
    }
}
